import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect, useRef } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Romania() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Romania') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [oName, setOName] = useState();
    const [regCode, setRegCode] = useState();
    const [address, setAddress] = useState();
    const [clientCode, setClientCode] = useState();
    const [contactPhone, setContactPhone] = useState();
    const [fax, setFax] = useState();

    const [fullName, setFullName] = useState();
    const [idNumber, setIdNumber] = useState();
    const [contactPhone2, setContactPhone2] = useState();
    const [email, setEmail] = useState();

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [address2, setAddress2] = useState('');
    const [partialPorting, setPartialPorting] = useState();

    const [provider, setProvider] = useState();
    const [date, setDate] = useState();


    //-----------------------------------------------fillform-------------------------------------------------//


    const fillForm = (form) => {
        const JSONData = form;
        document.querySelector('#oName').value = JSONData?.country?.details?.name ?? '';
        setOName(JSONData?.country?.details?.name ?? '');
        document.querySelector('#regCode').value = JSONData?.country?.details?.regCode ?? '';
        setRegCode(JSONData?.country?.details?.regCode ?? '');
        document.querySelector('#address').value = JSONData?.country?.details?.address ?? '';
        setAddress(JSONData?.country?.details?.address ?? '');
        document.querySelector('#clientCode').value = JSONData?.country?.details?.clientCode ?? '';
        setClientCode(JSONData?.country?.details?.clientCode ?? '');
        document.querySelector('#contactPhone').value = JSONData?.country?.details?.contactPhone ?? '';
        setContactPhone(JSONData?.country?.details?.contactPhone ?? '');
        document.querySelector('#fax').value = JSONData?.country?.details?.fax ?? '';
        setFax(JSONData?.country?.details?.fax ?? '');

        document.querySelector('#fullName').value = JSONData?.country?.details?.fullName ?? '';
        setFullName(JSONData?.country?.details?.fullName ?? '');
        document.querySelector('#idNumber').value = JSONData?.country?.details?.idNumber ?? '';
        setIdNumber(JSONData?.country?.details?.idNumber ?? '');
        document.querySelector('#contactPhone2').value = JSONData?.country?.details?.contactPhone2 ?? '';
        setContactPhone2(JSONData?.country?.details?.contactPhone2 ?? '');
        document.querySelector('#email').value = JSONData?.country?.details?.email ?? '';
        setEmail(JSONData?.country?.details?.email ?? '');

        document.querySelector('#startDateTime').value = JSONData?.country?.details?.startDateTime ?? '';
        setStartDateTime(JSONData?.country?.details?.startDateTime ?? '');

        document.querySelector('#endDateTime').value = JSONData?.country?.details?.endDateTime ?? '';
        setEndDateTime(JSONData?.country?.details?.endDateTime ?? '');

        document.querySelector('#address2').value = JSONData?.country?.details?.address2 ?? '';
        setAddress2(JSONData?.country?.details?.address2 ?? '');

        document.querySelector('#partialPorting').value = JSONData?.country?.details?.partialPorting ?? '';
        setPartialPorting(JSONData?.country?.details?.partialPorting ?? '');

        setTableDataRange(JSONData?.country?.details?.Number_Range ?? []);

        document.querySelector('#provider').value = JSONData?.country?.details?.provider ?? '';
        setProvider(JSONData?.country?.details?.provider ?? '');
        document.querySelector('#date').value = JSONData?.country?.details?.date ?? '';
        setDate(JSONData?.country?.details?.date ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };


    //-------------------------------------------Number Range Table-------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^\+?\s*(?:\d\s*){11}$/.test(row.sNumber);
                const isEndValid = /^\+?\s*(?:\d\s*){11}$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Romania",
            "details": {
                "name": oName,
                "regCode": regCode,
                "address": address,
                "clientCode": clientCode,
                "contactPhone": contactPhone,
                "fax": fax,
                "fullName": fullName,
                "idNumber": idNumber,
                "contactPhone2": contactPhone2,
                "email": email,
                "Number_Range": tableDataRange,
                "address2": address2,
                "startDateTime": startDateTime,
                "endDateTime": endDateTime,
                "partialPorting": partialPorting,
                "provider": provider,
                "date": date
            }
        },
        "email": sessionStorage.getItem('email')
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        if (!oName) {
            validationErrors.oName = 'Please fill in the operator name';
        }

        if (!regCode) {
            validationErrors.regCode = 'Please fill in the unique registration code';
        }

        if (!address) {
            validationErrors.address = 'Please fill in the Address';
        }

        if (!clientCode) {
            validationErrors.clientCode = 'Please fill in the Client code (Contract number)';
        }

        if (!contactPhone) {
            validationErrors.contactPhone = 'Please fill in the Contact Phone';
        }

        if (!fullName) {
            validationErrors.fullName = 'Please fill in the Full Name';
        }

        if (!idNumber) {
            validationErrors.idNumber = 'Please fill in the Id Number';
        }

        if (!contactPhone2) {
            validationErrors.contactPhone2 = 'Please fill in the Contact phone in legal representative';
        }

        if (!email) {
            validationErrors.email = 'Please fill in the Email';
        }

        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^\+?\s*(?:\d\s*){11}$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^\+?\s*(?:\d\s*){11}$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        if (!address2) {
            validationErrors.address2 = "Please fill in Address in Number details";
        }

        if (!startDateTime) {
            validationErrors.startDateTime = "Please fill in Start Date Time";
        }

        if (!endDateTime) {
            validationErrors.endDateTime = "Please fill in End Date Time";
        }

        if (!partialPorting) {
            validationErrors.partialPorting = 'Please specify whether the subscribe accepts partial porting.';
        }

        if (!provider) {
            validationErrors.provider = 'Please fill in the Current provider Name';
        }

        if (!date) {
            validationErrors.date = 'Please fill in the Date';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = oName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <Container>

                    <h2 className='heading'>Application identification …No. 0032022 / 22.09.2022</h2> <br></br>

                    <p>The applicant must be the holder of the contract for the provision of the electronic communications service..through the number(s) for which porting is requested.</p> <br></br>

                    <h2 className='heading'>Persoană juridică / DONOR</h2> <br></br>
                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('oName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Denumire*</label> <br />
                            <input
                                onChange={(e) => setOName(e.target.value)}
                                type="text"
                                id="oName"
                                placeholder=""
                                className={`inputbox ${validationStates.oName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('oName', /^[A-Za-z0-9 ]+$/)}

                            />
                            {hoveredField === 'oName' && (
                                <div className="hover-description">
                                    Operator Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('regCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Cod unic de înregistrare*</label> <br />
                            <input
                                onChange={(e) => setRegCode(e.target.value)}
                                type="text"
                                id="regCode"
                                placeholder=""
                                className={`inputbox ${validationStates.regCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput('regCode', /^\d{8}$/)}

                            />
                            {hoveredField === 'regCode' && (
                                <div className="hover-description">
                                    Unique Registration Code (8 digits)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Sediu*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[A-Za-z0-9 ]+$/)}

                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Address (e.g.: sos, 32 M, romania)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('clientCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Cod client (Număr contract)*</label> <br />
                            <input
                                onChange={(e) => setClientCode(e.target.value)}
                                type="text"
                                id="clientCode"
                                placeholder=""
                                className={`inputbox ${validationStates.clientCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput('clientCode', /^\d{9}$/)}

                            />
                            {hoveredField === 'clientCode' && (
                                <div className="hover-description">
                                    Client code (Contract number) (9 digits)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('contactPhone')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Telefon de contact*</label> <br />
                            <input
                                onChange={(e) => setContactPhone(e.target.value)}
                                type="text"
                                id="contactPhone"
                                placeholder=""
                                className={`inputbox ${validationStates.contactPhone === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactPhone', /^\+?\s*(?:\d\s*){11}$/)}
                            />
                            {hoveredField === 'contactPhone' && (
                                <div className="hover-description">
                                    Contact phone (e.g.: + 40212098300) (11 digits)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('fax')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Fax</label> <br />
                            <input
                                onChange={(e) => setFax(e.target.value)}
                                type="text"
                                id="fax"
                                placeholder=""
                                className={`inputbox ${validationStates.fax === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    // regex: allows only alphanumeric values
                                    const isValid = value === '' || /^[A-Za-z0-9 +]+$/.test(value);
                                    setValidationStates(prev => ({ ...prev, fax: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only alphanumeric values are allowed.'
                                        );
                                    }
                                }}
                            />
                            {hoveredField === 'fax' && (
                                <div className="hover-description">Fax</div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Reprezentant legal / Legal representative</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('fullName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nume și prenume*</label> <br />
                            <input
                                onChange={(e) => setFullName(e.target.value)}
                                type="text"
                                id="fullName"
                                placeholder=""
                                className={`inputbox ${validationStates.fullName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('fullName', /^[A-Za-z0-9 ]+$/)}

                            />
                            {hoveredField === 'fullName' && (
                                <div className="hover-description">
                                    Full Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('idNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Act de identitate (B.I./C.I./pașaport)*</label> <br />
                            <input
                                onChange={(e) => setIdNumber(e.target.value)}
                                type="text"
                                id="idNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.idNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('idNumber', /^[A-Za-z0-9 ]+$/)}

                            />
                            {hoveredField === 'idNumber' && (
                                <div className="hover-description">
                                    CI RX Bucharest, 11
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactPhone2')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Telefon de contact*</label> <br />
                            <input
                                onChange={(e) => setContactPhone2(e.target.value)}
                                type="text"
                                id="contactPhone2"
                                placeholder=""
                                className={`inputbox ${validationStates.contactPhone2 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactPhone2', /^\+?\s*(?:\d\s*){11}$/)}

                            />
                            {hoveredField === 'contactPhone2' && (
                                <div className="hover-description">
                                    Contact phone (e.g.: + 40212098300) (11 digits)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col xs={4}
                            onMouseEnter={() => handleMouseEnter('email')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Email*</label> <br />
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                id="email"
                                placeholder=""
                                className={`inputbox ${validationStates.email === false ? 'error' : ''}`}
                                onBlur={() => validateInput('email', /^.+$/)}
                            />
                            {hoveredField === 'email' && (
                                <div className="hover-description">
                                    Email
                                </div>
                            )}
                        </Col>
                    </Row>
                    <br />

                </Container>

                <br></br><br></br>

                <h2 className='heading'>Detalii Număr / Number Details</h2> <br></br>

                <Container>

                    <h4 className='text-decoration-underline'>*Numărul/numerelepentru carese solicită portarea / Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Interval de început al numerelor de telefon*</th>
                                <th>Interval de sfârșit al numerelor de telefon*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^\+?\s*(?:\d\s*){11}$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\+?\s*(?:\d\s*){11}$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only 11-digit numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Number Range Start
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only 11-digit numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^\+?\s*(?:\d\s*){11}$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\+?\s*(?:\d\s*){11}$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only 11-digit numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Number Range End
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only 11-digit numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address2')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Adresa la care este furnizat serviciul de comunicații electronice prin intermediul numărului/numerelor pentru care se solicită portarea*</label> <br />
                            <input
                                onChange={(e) => setAddress2(e.target.value)}
                                type="text"
                                id='address2'
                                placeholder=""
                                className={`inputbox ${validationStates.address2 === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address2', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'address2' && (
                                <div className="hover-description">
                                    Address (EX: sos,32 M, romania)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('startDateTime')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Momentul inițial(dată, oră)*</label> <br />
                            <input
                                type="datetime-local"
                                id="startDateTime"
                                value={startDateTime}
                                onChange={(e) => setStartDateTime(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.startDateTime === false ? 'error' : ''}`}
                                onBlur={() => validateInput('startDateTime', /^.*$/)}
                            />
                            {hoveredField === 'startDateTime' && (
                                <div className="hover-description">
                                    date and time desire porting from(EX : 9:00-13:00)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('endDateTime')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Momentul final(dată, oră)*</label> <br />
                            <input
                                type="datetime-local"
                                id="endDateTime"
                                value={endDateTime}
                                onChange={(e) => setEndDateTime(e.target.value)}
                                min={startDateTime || new Date().toISOString().slice(0, 16)} // End >= start
                                className={`inputbox ${validationStates.endDateTime === false ? 'error' : ''}`}
                                onBlur={() => validateInput('endDateTime', /^.*$/)}
                            />
                            {hoveredField === 'endDateTime' && (
                                <div className="hover-description">
                                    date and time desire porting to
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('partialPorting')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Abonatul acceptă portarea parțială8*</label> <br />
                            <select
                                id="partialPorting"
                                onChange={(e) => setPartialPorting(e.target.value)}
                                className={`inputbox ${validationStates.partialPorting === false ? 'error' : ''}`}
                                onBlur={() => validateInput('partialPorting', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="Yes">
                                    Yes
                                </option>
                                <option value="No">
                                    No
                                </option>
                            </select>
                            {hoveredField === 'partialPorting' && (
                                <div className="hover-description">
                                    The subscribe accepts partial porting
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <p><strong>NOTE: </strong>În situația în care termenul de portare este mai mare de 3 zile lucrătoare, furnizorul acceptor va preciza dacă aceasta a fost opțiunea abonatului sau a
                        furnizorului acceptor.</p>
                    <p>Se poate preciza tipul de acces (de exemplu, ISDN-BRA, ISDN-PRA, PABX etc.).  Documente anexate, dacă este cazul:</p>
                    <p>1. Copie de pe actul de identitate;</p>
                    <p> 2. Copie de pe ultima factură emisă de furnizorul donor;</p>
                    <p>3. În cazul reprezentării persoanelor fizice, procura sub semnătură privată în original.</p>

                    <br></br>

                    <Row>

                        <Col xs={4}
                            onMouseEnter={() => handleMouseEnter('provider')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Furnizorul care oferă în prezent serviciul*</label> <br />
                            <input
                                onChange={(e) => setProvider(e.target.value)}
                                type="text"
                                id="provider"
                                placeholder=""
                                className={`inputbox ${validationStates.provider === false ? 'error' : ''}`}
                                onBlur={() => validateInput('provider', /^[A-Za-z0-9 ]+$/)}

                            />
                            {hoveredField === 'provider' && (
                                <div className="hover-description">
                                    Current provider Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Date*</label> <br />
                            <input
                                type="date"
                                id="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Date of signing contract
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>

            </div>

        </div>
    );
}

export default Romania;